import React, {useEffect} from 'react'
import Layout from "../common/Layout";
import {Navigate} from "react-router-dom";


const Error = () => {
    useEffect(() => {
        // 👇 add class to body element
        document.body.classList.add('light');
    }, []);




    return (
        <Layout>
            {<Navigate to="/error" />}
            <div className="error-area ptb--200 ptb_sm--60 ptb_md--80">
                <div className="container">
                    <div className="row align-item-center">
                        <div className="col-lg-12">
                            <div className="error-inner">
                                <h1>404</h1>
                                <h2 className="title">Oups.</h2>
                                <div className="view-more-button">
                                    <a className="btn-default" href="/">Revenir à la page d'accueil</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default Error;